module.exports = __webpack_public_path__ + "static/media/hamburger.d7e47f05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/poop/navbar/hamburger.svg
// module id = 626
// module chunks = 6